
import {NavLink} from "react-router-dom"
import {useState} from "react"
import {motion, useScroll, useMotionValueEvent} from "motion/react"
import icon from "../../src/assets/ridgewood-icon-large.png"
import { BsMoon } from "react-icons/bs";
import { FiSun } from "react-icons/fi"

interface HeaderProps {
  switchColorScheme: () => void;
  darkMode?: boolean;
  setDarkMode: (value: boolean) => void;
}

export default function Header(props: HeaderProps) {
    const { scrollY } = useScroll();
    const [hidden, setHidden] = useState(false);

    useMotionValueEvent(scrollY, "change", (latest) => {
        const previous = scrollY.getPrevious() ?? 0;
        if (previous !== undefined && latest > previous && latest > 150){
            setHidden(true)
        } else {
            setHidden(false)
        }
    })
    
    return <>
        <motion.div
            variants={{
                visible: {y: 0},
                hidden: {y: "-100%" }
            }}
            animate={hidden ? "hidden": "visible"}
            transition={{duration: 0.35, ease: "easeInOut"}}
            className="header"
        >
            <NavLink to="/" className="logo">
                <div className="logo quattrocento-bold">
                    <img src={icon} height="50px"/>
                    <h1>Ridgewood</h1>
                </div>
            </NavLink>
            <div className="header-links">
                <NavLink to="/Events">Events</NavLink>
                <NavLink to="/faq">FAQ</NavLink>
                <NavLink to="/Support">Support</NavLink>
                <NavLink to="/contact">Contact</NavLink>
            </div>
            <div className="theme-btn" onClick={props.switchColorScheme}>
                <p>{props.darkMode ? <FiSun /> : <BsMoon />}</p>
            </div>
        </motion.div>
    </>
}